import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import NKFIAK_en from '../img/NKFIA2019_EN.png';
import NKFIAK_hu from '../img/NKFIA2019_HU.png';
import { useLanguage } from '../LanguageContext';

const ID = "149107";

const funding = {
  en: `Project no. MEC_SZ ${ID} has been implemented with the support provided by the Ministry of Culture and Innovation of Hungary from the National Research, Development and Innovation Fund, financed under the MEC_SZ_24 funding scheme.`,
  hu: `A MEC_SZ ${ID} számú projekt a Kulturális és Innovációs Minisztérium Nemzeti Kutatási Fejlesztési és Innovációs Alapból nyújtott támogatásával, a MEC_SZ_24 pályázati program finanszírozásában valósult meg.`,
};

export default function Footer() {
  const { language } = useLanguage();

  return (
    <Box
      sx={{
        width: '100%',
        backgroundColor: 'white',
        color: 'black',
        padding: { xs: '20px 0', sm: '30px 0' },
      }}>
      <Container maxWidth="lg">

        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' }, // Stack on mobile, row on desktop
            justifyContent: 'space-between',
            alignItems: { xs: 'center', sm: 'center' }, // Center on mobile
            gap: { xs: 2, sm: 4 },
            textAlign: { xs: 'center', sm: 'left' }, // Center text on mobile
          }}>
          <Box
            component="img"
            src={language === 'en' ? NKFIAK_en : NKFIAK_hu}
            alt={language === 'en' ? 'NKFIAK English Logo' : 'NKFIAK Hungarian Logo'}
            sx={{
              height: { xs: '60px', sm: '80px', md: '100px' },
              maxWidth: '100%', // Prevent overflow
            }}/>
          
          <Box sx={{ maxWidth: { xs: '100%', sm: '70%' } }}>
            <Typography
              variant="body1"
              sx={{
                color: '#333',
                fontWeight: 300,
                textAlign: 'justify',
              }}>
              {language === 'en' ? funding.en : funding.hu}
            </Typography>
          </Box>

        </Box>

        <Box
          sx={{
            mt: 4,
            pt: 2,
            borderTop: '1px solid gray',
            textAlign: 'center',
          }}>
          <Typography
            variant="body2"
            sx={{
              color: 'gray',
              fontWeight: 300,
            }}>
            Play & Society © {new Date().getFullYear()} {language === 'en' ? "All rights reserved." : "Minden jog fenntartva."}
          </Typography>

        </Box>
      </Container>
    </Box>
  );
}
